const MyAccountActionType = {
  SET_LOG_IN: 'MY_ACCOUNT_SET_LOG_IN',
  STORE_CUSTOMER_INFO: 'MY_ACCOUNT_STORE_CUSTOMER_INFO',
  STORE_PAY_NOW_ERROR: 'MY_ACCOUNT_STORE_PAY_NOW_ERROR',
  RESET_ALL: 'MY_ACCOUNT_RESET_ALL',
  STORE_UPDATE_PAYMENT_SUCCESS: 'MY_ACCOUNT_STORE_UPDATE_PAYMENT_SUCCESS',
  STORE_PAY_NOW_SUCCESS: 'MY_ACCOUNT_STORE_PAY_NOW_SUCCESS',
  STORE_RESET_PASSWORD_SUCCESS: 'MY_ACCOUNT_STORE_RESET_PASSWORD_SUCCESS',
  CLEAR_ALL_DASHBOARD_NOTIFICATIONS: 'MY_ACCOUNT_CLEAR_ALL_DASHBOARD_NOTIFICATIONS',
  SET_MOVE_TO_PLAN: 'MY_ACCOUNT_SET_MOVE_TO_PLAN',
  STORE_AVAILABLE_PLANS: 'MY_ACCOUNT_STORE_AVAILABLE_PLANS'
};

export default MyAccountActionType;



/** WEBPACK FOOTER **
 ** ./src/common/MyAccountActionType.js
 **/